import DateHandler from "@/composables/handlers/DateHandler";
import BaseModel from "./BaseModel";
import { capitalizeWords } from "@/composables/textUtils";

/**
 * BlogPost
 */
export default class BlogPost extends BaseModel{
  constructor({
    id,
    author_name,
    title,
    text,
    post_photo,
    status,
    tags,
    created_at,
    updated_at
  }) {
    super();

    this.id = id || null;
    this.author_name = author_name || null;
    this.title = title || null;
    this.text = text || null;
    this.post_photo = post_photo || null;
    this.status = status || null;
    this.tags = tags || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
  }

  /**
   * Gets BlogPost tags
   * @returns {Array}
   */
  getTags() {
    if (!this.tags) {
      return [];
    }

    return JSON.parse(this.tags || []); 
  }

  /**
   * Gets BlogPost photo
   * @returns {String}
   */
  getPhoto() {
    if (this.post_photo && this.post_photo.includes('data:image/jpeg;base64,')) {
      return this.post_photo;
    }
    return this.post_photo ? `data:image/jpeg;base64,${this.post_photo}` : '';
  }

  /**
   * Gets BlogPost last created date
   * @returns {String}
   */
  getCreatedDate() {
    return DateHandler.format(this.created_at, 'DATE_SHORT');
  }

  /**
   * Gets BlogPost last updated date
   * @returns {String}
   */
  getUpdatedDate() {
    return DateHandler.format(this.updated_at, 'DATE_SHORT');
  }

  /**
   * Gets text withou tags and shortened
   * @param {integer} size
   * @returns {string}
   */
  getShortenedText(size = null) {
    if (size == null) {
      size = window.innerWidth > 500 ? 100 : 20;
    }

    if (!this.text) return '';

    const noTags = this.text.replace(/<[^>]*>?/gm, '');

    const doc = new DOMParser().parseFromString(noTags, 'text/html');
    const decodedText = doc.documentElement.textContent || "";

    return decodedText.trim().substring(0, size) + (decodedText.length > size ? '...' : '');
  }

  /**
   * Gets reading time by calculating text size
   */
  getReadingTime() {
    if (!this.text) return 0;

    let plainText = this.text.replace(/<[^>]*>?/gm, '');

    plainText = plainText
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');

    const cleanText = plainText.replace(/\s+/gu, ' ').trim();
    const wordCount = cleanText.split(' ').length;

    const wordsPerMinute = 225;
    const minutes = Math.ceil(wordCount / wordsPerMinute);

    return minutes;
  }

  /**
   * Gets author_name capitalized
   * @returns {string}
   */
  getAuthorName() {
    return capitalizeWords(this.author_name);
  }
}
